<template>
  <div class="custom-popup">
    <!-- 筛选表单 -->
    <el-card class="filter-card" shadow="never" header="库存不足(已上架)">
      <el-form :model="filterForm" :inline="true" size="mini">
        <!-- <el-form-item label="关键词">
          <el-input
            v-model="filterForm.keyword"
            placeholder="请输入关键词"
            clearable
            @clear="handleFilter"
            @keyup.enter.native="handleFilter"
          >
            <el-button slot="append" icon="el-icon-search" @click="handleFilter" />
          </el-input>
        </el-form-item> -->

        <el-form-item label="商品类别" style="margin-bottom: 0;padding: 0 20px;">
          <el-select v-model="filterForm.type" clearable placeholder="请选择类别" @change="handleFilter">
            <el-option v-for="item in typeOptions" :key="item.id" :label="item.label" :value="item.label" />
          </el-select>
        </el-form-item>

        <!-- <el-form-item label="状态">
          <el-select v-model="filterForm.status" clearable placeholder="请选择状态" @change="handleFilter">
            <el-option label="启用" value="1" />
            <el-option label="禁用" value="0" />
          </el-select>
        </el-form-item> -->
      </el-form>
    </el-card>

    <!-- 列表区域 -->
    <div ref="listContainer" class="list-container">
      <div
        v-infinite-scroll="loadMore"
        infinite-scroll-disabled="loading"
        infinite-scroll-distance="50"
        class="infinite-list"
      >
        <el-card
          v-for="item in listData"
          :key="item.id"
          class="list-item"
          shadow="hover"
        >
          <div class="item-content">
            <!-- 图片展示 -->
            <div class="item-image">
              <el-image
                :src="item.image"
                :preview-src-list="[item.image]"
                fit="cover"
                lazy
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline" />
                </div>
              </el-image>
            </div>

            <!-- 内容信息 -->
            <div class="item-info">
              <h4 class="item-title">{{ item.title }}</h4>
              <p class="item-desc">{{ item.description }}</p>
              <div class="item-meta">
                <span class="item-type">{{ item.typeText }}</span>
                <span class="item-time">{{ item.createTime }}</span>
              </div>
              <div class="item-stock">
                <span class="stock-label">库存:</span>
                <span class="stock-value">{{ item.stock }}</span>
              </div>
              <div class="item-actions">
                <el-button size="mini" type="primary" @click="handleView(item)">查看并修改</el-button>
                <!-- <el-button size="mini" @click="handleEdit(item)">编辑</el-button> -->
              </div>
            </div>
          </div>
        </el-card>

        <!-- 加载状态 -->
        <div v-if="loading" class="loading-text">
          <i class="el-icon-loading" /> 加载中...
        </div>
        <div v-if="noMore" class="loading-text">没有更多数据了</div>
      </div>
    </div>

    <!-- 操作按钮 -->
    <div class="popup-actions">
      <!-- <el-button size="small" @click="handleRefresh">
        <i class="el-icon-refresh"></i> 刷新
      </el-button> -->
      <el-button size="small" type="primary" @click="handleClose">
        <i class="el-icon-close" /> 关闭
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomPopup',
  props: {
    // 是否显示弹窗
    visible: {
      type: Boolean,
      default: false
    },
    shopList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      // 筛选表单
      filterForm: {
        keyword: '',
        type: '全部',
        status: ''
      },
      // 列表数据
      //   listData: [],
      // 分页信息
      //   pagination: {
      //     page: 1,
      //     pageSize: 10,
      //     total: 0
      //   },
      // 加载状态
      loading: false,
      // 是否没有更多数据
      noMore: false
      // 模拟数据总条数
    //   totalData: 50
    }
  },
  computed: {
    // 计算是否还有更多数据
    hasMore() {
      return this.listData.length < this.totalData
    },
    typeOptions() {
      const types = [{ label: '全部', value: '全部' }]
      const seen = new Set()
      for (let i = 0; i < this.shopList.length; i++) {
        const item = this.shopList[i]
        if (!item || !item.storeCategory) continue
        const value = item.storeCategory.id
        const label = item.storeCategory.cateName
        if (seen.has(label)) continue
        seen.add(label)
        types.push({ label, value })
      }
      return types
    },
    totalData() {
      return this.shopList.length
    },
    listData() {
      return this.shopList.filter(item => this.filterForm.type === '全部' ? true : item.storeCategory.cateName === this.filterForm.type).map(item => {
        return {
          id: item.id,
          title: item.storeName,
          description: item.storeInfo,
          image: item.image,
          type: item.storeCategory.id,
          typeText: item.storeCategory.cateName,
          status: item.isShow.toString(),
          createTime: item.addTime,
          stock: item.stock
        }
      })
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    // 初始化数据
    async initData() {
      this.loading = true
      try {
        // 模拟API调用
        // await this.fetchData()
      } catch (error) {
        console.error('数据加载失败:', error)
        this.$message.error('数据加载失败')
      } finally {
        this.loading = false
      }
    },

    // 模拟获取数据
    // fetchData() {
    //   return new Promise((resolve) => {
    //     setTimeout(() => {
    //       const newData = this.generateMockData()
    //       if (this.pagination.page === 1) {
    //         this.listData = newData
    //       } else {
    //         this.listData = [...this.listData, ...newData]
    //       }
    //       this.noMore = !this.hasMore
    //       resolve()
    //     }, 800)
    //   })
    // },

    // 生成模拟数据
    // generateMockData() {
    //   const types = ['1', '2', '3']
    //   const typeTexts = { '1': '类型1', '2': '类型2', '3': '类型3' }
    //   const statuses = ['0', '1']

    //   const data = []
    //   const startIndex = (this.pagination.page - 1) * this.pagination.pageSize
    //   const endIndex = Math.min(startIndex + this.pagination.pageSize, this.totalData)

    //   for (let i = startIndex; i < endIndex; i++) {
    //     data.push({
    //       id: i + 1,
    //       title: `项目标题 ${i + 1}`,
    //       description: `这是一个很长的描述信息，用于测试滚动效果。项目 ${i + 1} 的详细描述内容。`,
    //       image: `https://picsum.photos/200/150?random=${i + 1}`,
    //       type: types[i % 3],
    //       typeText: typeTexts[types[i % 3]],
    //       status: statuses[i % 2],
    //       createTime: this.formatDate(new Date())
    //     })
    //   }
    //   return data
    // },

    // 格式化日期
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },

    // 筛选处理
    handleFilter() {
    //   this.pagination.page = 1
    //   this.listData = []
    //   this.noMore = false
    //   this.initData()
    },

    // 加载更多
    async loadMore() {
      if (this.loading || this.noMore) return

      //   this.pagination.page++
      this.loading = true

      try {
        // await this.fetchData()
      } catch (error) {
        console.error('加载更多失败:', error)
        // this.pagination.page-- // 回退页码
      } finally {
        this.loading = false
      }
    },

    // 查看详情
    handleView(item) {
      // 跳转到商品编辑页并关闭弹窗（让 tagsView 记录为标签）
      const path = '/shop/goodsEdit/' + item.id
      this.$router.push({ path })
      this.$emit('close')
    },

    // 编辑项目
    handleEdit(item) {
      this.$message.info(`编辑项目: ${item.title}`)
      // 这里可以触发编辑弹窗
    },

    // 刷新数据
    // handleRefresh() {
    // //   this.pagination.page = 1
    // //   this.listData = []
    //   this.noMore = false
    //   this.initData()
    //   this.$message.success('数据已刷新')
    // },

    // 关闭弹窗
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.custom-popup >>> .el-card__header {
  border-bottom: none !important;
  font-size: 16px;
  font-weight: 600;
}
.custom-popup {
  width: 400px;
  height: 600px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.filter-card {
  margin: 0;
  border-radius: 0;
  border: none;
  /* border-bottom: 1px solid #ebeef5;
  padding: 16px; */
}

.filter-card >>> .el-card__body {
  padding: 0;
}

.list-container {
  flex: 1;
  overflow: hidden;
  position: relative;
}

.infinite-list {
  height: 100%;
  overflow-y: auto;
  padding: 8px;
}

.list-item {
  margin-bottom: 12px;
  transition: all 0.3s;
}

.list-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.item-content {
  display: flex;
  gap: 12px;
}

.item-image {
  flex-shrink: 0;
  width: 80px;
  height: 60px;
}

.item-image >>> .el-image {
  width: 100%;
  height: 100%;
  border-radius: 4px;
  overflow: hidden;
}

.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 20px;
}

.item-info {
  flex: 1;
  min-width: 0;
}

.item-title {
  margin: 0 0 4px 0;
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.item-desc {
  margin: 0 0 8px 0;
  font-size: 12px;
  color: #606266;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.item-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  font-size: 12px;
  color: #909399;
}

.item-stock {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 8px;
  font-size: 12px;
}

.stock-label {
  color: #606266;
  font-weight: 500;
}

.stock-value {
  color: #e6a23c;
  font-weight: 600;
}

.item-actions {
  display: flex;
  gap: 8px;
}

.loading-text {
  text-align: center;
  padding: 16px;
  color: #909399;
  font-size: 14px;
}

.popup-actions {
  padding: 16px;
  border-top: 1px solid #ebeef5;
  display: flex;
  justify-content: end;
  background: #fafafa;
}

/* 滚动条样式 */
.infinite-list::-webkit-scrollbar {
  width: 6px;
}

.infinite-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.infinite-list::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.infinite-list::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
